import { render, staticRenderFns } from "./Workplaces.vue?vue&type=template&id=97f6c74e&scoped=true&"
import script from "./Workplaces.vue?vue&type=script&lang=js&"
export * from "./Workplaces.vue?vue&type=script&lang=js&"
import style0 from "./Workplaces.vue?vue&type=style&index=0&id=97f6c74e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f6c74e",
  null
  
)

export default component.exports